module.exports = __webpack_public_path__ + "img/uk-purchase-banner.d6d10bcb.png";